import React from 'react';

import { useCartContext } from '@fhs-legacy/frontend/src/state/cart';
import { isDelivery } from '@fhs-legacy/frontend/src/utils/service-mode';

import { CheckoutDeliveryDetails } from './delivery';
import { CheckoutPickupDetails } from './pickup';
import { ServiceModeDetailsWrapper } from './service-mode-details-wrapper';

export { ServiceModeDetailsWrapper };

export default function ServiceModeDetails() {
  const { serviceMode } = useCartContext();
  const isDeliveryOrder = isDelivery(serviceMode);

  return (
    <ServiceModeDetailsWrapper isDeliveryOrder={isDeliveryOrder}>
      {isDeliveryOrder ? <CheckoutDeliveryDetails /> : <CheckoutPickupDetails />}
    </ServiceModeDetailsWrapper>
  );
}
